import React, { useContext, useState } from 'react';
import '../../css/numberRange.css';
import Icon from '../../assets/icons/icon';
import { useSelector } from 'react-redux';
import { AgentContext } from '../../context/AgentContext';

const NumberRange = ({
  title = 'Lead Age',
  toolTip=undefined,
  initial_minVal = 12,
  initial_maxVal = 90,
  incrementAmount = 1,
  onCancel = () => { },
  onSave = () => { },
}) => {
  const [minValue, setMinValue] = useState(initial_minVal);
  const [maxValue, setMaxValue] = useState(initial_maxVal);

  const [showTooltip, setShowTooltip] = useState(false);

  const [minError, setMinError] = useState('');
  const [maxError, setMaxError] = useState('');

const validateAge = (value) => {
  if (value < initial_minVal || value > initial_maxVal) {
    return `Age must be between ${initial_minVal}-${initial_maxVal}.`;
  }
  return '';
};

const handleMinChange = (e) => {
  const value = parseInt(e.target.value, 10);
  setMinValue(value);
  setMinError(validateAge(value));
};

const handleMaxChange = (e) => {
  const value = parseInt(e.target.value, 10);
  setMaxValue(value);
  setMaxError(validateAge(value));
};

  const isSaveDisabled = isNaN(minValue) || isNaN(maxValue) || !!minError || !!maxError;

const {isB2B} = useContext(AgentContext)
  return (
    <div className="number-range-container">
      <div className="number-range-body">
        <div className="number-range-title">
          <div className="title-text">{title}</div>
          {
            toolTip
                ? (
                    <div
                      className="tooltip-target"
                      onMouseEnter={() => setShowTooltip(true)}
                      onMouseLeave={() => setShowTooltip(false)}
                    >
                      <Icon color="#1570EF" name={'info-circle-q'} size={16} className={``} adjust="" style={{rotate: "180deg", marginTop: "-7px"}} />
                      {showTooltip && (
                        <div className="custom-tooltip">
                          {toolTip}
                          <div className="tooltip-arrow" />
                        </div>
                      )}
                    </div>
                )
                : null
          }
        </div>
        <div className="number-range-input-group">
          <div className="input-box">
            <div className="label">Min</div>
            <input
              type="number"
              value={minValue}
              onChange={handleMinChange}
              step={incrementAmount}
              className={`range-input ${minError ? 'error' : ''}`}
            />
          </div>

          <div className="range-separator">–</div>

          <div className="input-box">
            <div className="label">Max</div>
            <input
              type="number"
              value={maxValue}
              onChange={handleMaxChange}
              step={incrementAmount}
              className={`range-input ${maxError ? 'error' : ''}`}
            />
          </div>
        </div>

        {(maxError || minError) && <div className="number-range-input-group errors-flexdiv">
          {minError && <div className="error-text" style={{ visibility: minError ? 'visible' : 'hidden' }}>
            {minError}
          </div>}
          {maxError && <div className="error-text" style={{ visibility: maxError ? 'visible' : 'hidden' }}>
            {maxError}
          </div>}

        </div>}
      </div>

      <div className="number-range-actions">
        <button className={`${isB2B ? 'b2b ' : ''}cancel-btn`} onClick={onCancel}>Cancel</button>
        <button className={`${isB2B ? 'b2b ' : ''}save-btn ${isSaveDisabled ? 'saveDisable' : 'saveEnable'}`} disabled={isSaveDisabled} onClick={() => onSave(minValue, maxValue)}>Save</button>
      </div>
    </div>
  );
};

export default NumberRange;
